import { http } from '../../config/axios'

export default function getTipoBilhete(): Promise<any> {
  return http
    .get('api/servico/tiposbilhete')
    .then((res) => {
      return res.data as any
    })
    .catch((error) => {
      console.error('Erro getTipoBilhete', error)
      throw Error(error.response.data)
    })
}
